import Indicator from '../Indicator';
import subpixel from '../util/canvasSubpixelOffset';

/** Price Rate of Change indicator */
export default class PROCIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'proc',
			name: 'Price Rate of Change',
			description:
				'A technical indicator that measures the percentage change between the most recent price and the price "n" periods in the past.',
			inputs: [{ name: 'period', value: 25 }],
			componentSeries: [
				{ id: 'proc' }
			]
		};
	}

	/**
	 * Renders the indicator zero line
	 * @param {CanvasRenderingContext2D} ctx Chart canvas context
	 * @param {number} yScale Y axis scale
	 */
	_renderZeroLine(ctx, yScale) {
		const left = this.panel.size.padding.left;
		const y0 = subpixel.px(yScale(0));
		const style = this.params.style;

		ctx.beginPath();
		ctx.lineWidth = style.zero.width;
		ctx.strokeStyle = style.zero.color;
		if (style.zero.lineDash) ctx.setLineDash(style.zero.lineDash.split(/\s*,\s*/));
		ctx.moveTo(left, y0);
		ctx.lineTo(this.panel.size.width + left, y0);
		ctx.stroke();
		if (style.zero.lineDash) ctx.setLineDash([]);
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		const ctx = this.panel.rootContext;
		const yScale = this.yScale;

		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});

		this._renderZeroLine(ctx, yScale);
	}
}
